// Dependencies
import React from 'react';
import radium from 'radium';
import Button from '../../../components/button/Button.tsx';
import ButtonEventsOverview from '../../../components/button-events-overview/ButtonEventsOverview.jsx';
import history from '../../../lib/history';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

interface SeatingplanBookingBtnProps {
	eventUUID: string
}

const defaultProps = {
	eventUUID: '',
};

function SeatingplanBookingBtn(propsIn: SeatingplanBookingBtnProps) {
	const context = React.useContext(ThemeContext);
	const props = {...defaultProps, ...propsIn};
	const style = {
		container: {
			margin: ' 0.5em 0 1.5em 0',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	function openSeatingplanBooking() {
		const seatingplanPageUrl = `sp/${props.eventUUID}/seatingplan`;
		// @ts-expect-error history string
		history.push(seatingplanPageUrl);
	}

	return (
		<div style={style.container}>
			<Button
				name="seatingplanBooking"
				buttonText={context.themeManager.getThemeTextOrHardcodedDefault('toSeatingplanBookingBtn')}
				btnStyle="highlight"
				onClick={openSeatingplanBooking}
			/>
			<ButtonEventsOverview
				btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
				buttonContainerStyle={style.buttonContainer}
				iconName="angle-double-left"
			/>
		</div>
	);
}

export default radium(SeatingplanBookingBtn);
